import { THEME } from "../theme.ts";

export const CSS = `/* Sorted hosted quiz — every value comes from src/theme.ts, generated from DESIGN.md. A host site overrides the --s-* variables below (EMBED1). */
:host{display:block;container-type:inline-size;${THEME}
  --s-accent:var(--sorted-color-primary); --s-accent-hover:var(--sorted-color-primary-hover); --s-accent-fg:var(--sorted-color-on-primary); --s-accent-50:var(--sorted-color-primary-tint);
  --s-surface:var(--sorted-color-surface); --s-surface-raised:var(--sorted-color-surface-raised); --s-surface-muted:var(--sorted-color-surface-muted);
  --s-text:var(--sorted-color-ink); --s-text-2:var(--sorted-color-ink-soft); --s-text-3:var(--sorted-color-ink-faint);
  --s-border:var(--sorted-color-line); --s-border-strong:var(--sorted-color-line-strong);
  --s-radius:var(--sorted-radius-container); --s-radius-sm:var(--sorted-radius-control);
  --s-font:var(--sorted-font-body);
}
*{box-sizing:border-box;margin:0;padding:0}
.root{font-family:var(--s-font);background:var(--s-surface);color:var(--s-text);-webkit-font-smoothing:antialiased;overflow-x:hidden}
.q{min-height:100vh;display:flex;flex-direction:column;padding:16px}
.q__top{display:flex;align-items:center;justify-content:space-between;height:48px}
.q__sender{font-size:14px;line-height:20px;font-weight:600;color:var(--s-text)}
.q__prog{display:grid;gap:8px}.q__count{font-size:12px;line-height:16px;color:var(--s-text-2);font-variant-numeric:tabular-nums}.q__bar{display:block;width:100%;height:4px;background:var(--s-surface-muted);border-radius:var(--sorted-radius-track-thin);overflow:hidden}.q__bar i{display:block;height:100%;background:var(--s-accent);border-radius:var(--sorted-radius-track-thin)}
.q__back{display:inline-flex;align-items:center;gap:8px;min-height:48px;padding:0 4px;color:var(--s-text-2);font-size:14px;font-weight:500;text-decoration:none;border-radius:var(--s-radius-sm)}
.q__back svg{width:16px;height:16px}
.q__body{flex:1;display:grid;align-content:start;gap:32px;padding:24px 0 32px}
.q__head{display:grid;gap:12px}
.q__hook{font-size:30px;line-height:36px;font-weight:600;letter-spacing:-0.025em}
.q__lead{font-size:16px;line-height:24px;color:var(--s-text-2)}
.q__for{font-size:13px;line-height:20px;color:var(--s-text-2);margin-bottom:8px}
.q__ask{display:grid;gap:16px;max-width:640px}
.q__question{font-size:20px;line-height:28px;font-weight:600}
.q__hint{font-size:14px;line-height:20px;color:var(--s-text-3);margin-top:-8px}
.q__choices{display:grid;gap:8px}
.choice{display:flex;align-items:center;min-height:56px;padding:0 20px;background:var(--s-surface);border:1px solid var(--s-border);border-radius:var(--s-radius);font:inherit;font-size:16px;font-weight:500;color:var(--s-text);text-align:left;cursor:pointer;width:100%}
.choice:hover{border-color:var(--s-border-strong);background:var(--s-surface-raised)}
.choice:focus-visible,.q__back:focus-visible,.btn:focus-visible,.q__text:focus-visible{outline:2px solid var(--s-accent);outline-offset:2px}
.choice[aria-checked="true"]{border-color:var(--s-accent);background:var(--s-accent-50)}
.q__text{width:100%;min-height:144px;padding:16px;border:1px solid var(--s-border);border-radius:var(--s-radius);font:inherit;font-size:16px;line-height:24px;color:var(--s-text);resize:none}
.q__text::placeholder{color:var(--s-text-3)}
.q__actions{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.btn{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 20px;border-radius:var(--s-radius-sm);font:inherit;font-size:16px;font-weight:500;cursor:pointer;border:1px solid transparent}
.btn--primary{background:var(--s-accent);color:var(--s-accent-fg)}
.btn--primary:hover{background:var(--s-accent-hover)}
.btn--ghost{background:var(--s-surface);color:var(--s-text-2);border-color:var(--s-border)}
.btn--ghost:hover{background:var(--s-surface-raised);border-color:var(--s-border-strong)}
/* inline embed (B3): size to content on a host page; popup + hosted page keep full height */
:host([data-mode="inline"]) .q,:host([data-mode="inline"]) .nl,:host([data-mode="inline"]) .r{min-height:0}
/* not-live */
.nl{min-height:100vh;display:grid;place-items:center;padding:16px}
.nl p{font-size:20px;line-height:28px;font-weight:500;color:var(--s-text-2);text-align:center}
/* desktop (CONV1 Q-2): one centered 720 px column; <=760 unchanged */
@container (min-width:761px){
  .q{padding:32px;max-width:784px;margin:0 auto}
  .q__body{align-content:center;padding:32px 0}
  .q__head,.q__ask,.q__form{max-width:none}
  .q__hook{font-size:40px;line-height:48px;font-weight:700;letter-spacing:-0.025em}
  .q__question{font-size:20px;line-height:28px;font-weight:600}
  .q__question--solo{font-size:28px;line-height:36px;font-weight:700;letter-spacing:-0.02em}
  .q__choices{gap:12px}
}

/* contact step */
.q__form{display:grid;gap:12px;max-width:640px}
.q__field{display:grid;gap:6px;font-size:14px;font-weight:500;color:var(--s-text-2)}
.q__input{width:100%;min-height:48px;padding:0 16px;border:1px solid var(--s-border);border-radius:var(--s-radius);font:inherit;font-size:16px;color:var(--s-text);background:var(--s-surface)}
.q__input:focus-visible,.q__box:focus-visible{outline:2px solid var(--s-accent);outline-offset:2px}
/* SORTEDSMS1 box: the text-consent row — a 20 px box beside its terms label (.r__note size and colour); the whole row is the tap target */
.q__check{display:grid;grid-template-columns:20px 1fr;gap:10px;align-items:start;cursor:pointer}
.q__box{width:20px;height:20px;accent-color:var(--s-accent);cursor:pointer}
.q__err{font-size:14px;color:var(--sorted-color-error-quiz);min-height:20px}
.q__skip{justify-self:start;min-height:48px;padding:0 4px;background:none;border:0;font:inherit;font-size:14px;color:var(--s-text-2);text-decoration:underline;cursor:pointer}
.q__welcome{display:grid;justify-items:start;gap:0}
.q__skip:focus-visible{outline:2px solid var(--s-accent);outline-offset:2px}
.q__back--hidden{visibility:hidden}

/* result (RESULT1) — from design/result1/result.css */
.r{min-height:100vh;display:flex;flex-direction:column}
.r__main{flex:0 0 auto;display:grid;align-content:center;padding:32px 16px;gap:24px}
.r__col{width:100%;max-width:720px;margin:0 auto;display:grid;gap:24px}
.r__type{font-size:14px;line-height:20px;font-weight:500;color:var(--s-text-2);text-transform:uppercase;letter-spacing:.06em}
.r__name{font-size:30px;line-height:36px;font-weight:600;letter-spacing:-0.025em}
.r__said{font-size:16px;line-height:24px;color:var(--s-text-2)}
.r__said q{quotes:"\\201C" "\\201D";color:var(--s-text)}
.r__number{display:grid;gap:8px}
.r__figure{font-size:48px;line-height:56px;font-weight:600;letter-spacing:-0.03em;font-variant-numeric:tabular-nums}
.r__label{font-size:20px;line-height:28px;font-weight:500}
.r__label--second{margin-top:4px}
.r__basis{font-size:14px;line-height:20px;color:var(--s-text-2)}
.r__cta{display:grid;gap:8px}
.btn--wide{width:100%;padding:12px 20px;line-height:24px;text-align:center;text-decoration:none}
.r__book{display:grid;gap:12px}
.r__pick{font-size:20px;line-height:28px;font-weight:500}
.r__frame{width:100%;height:720px;border:1px solid var(--s-border);border-radius:var(--s-radius);background:var(--s-surface)}
.r__proof{flex:1;background:var(--s-surface-muted);padding:32px 16px}
.r__quote{max-width:720px;margin:0 auto;display:grid;gap:12px}
.r__note{font-size:14px;line-height:20px;color:var(--s-text-2)}
.r__how summary{font-size:14px;line-height:20px;color:var(--s-accent);cursor:pointer}
.r__how[open] summary{margin-bottom:4px}
.r__quote p{font-size:20px;line-height:28px;font-weight:500}
.r__quote p::before{content:"\\201C"}.r__quote p::after{content:"\\201D"}
.r__who{font-size:14px;line-height:20px;color:var(--s-text-2)}
@container (min-width:900px){
  .r__main{padding:48px 32px}
  .r__name{font-size:36px;line-height:44px}
  .r__figure{font-size:60px;line-height:64px}
  .btn--wide{width:auto;justify-self:start;padding:0 32px}
  .r__proof{padding:48px 32px}
  .r__frame{height:600px}
}

/* consent bar */
.consent{font-family:var(--s-font);position:fixed;left:0;right:0;bottom:0;z-index:10;display:flex;flex-wrap:nowrap;align-items:center;gap:12px;padding:7px 16px;background:var(--s-surface);border-top:1px solid var(--s-border);font-size:12px;line-height:16px;color:var(--s-text-2)}
.consent p{flex:1 1 auto;min-width:0}
.consent--embed{position:static;z-index:auto}
.consent a{color:var(--s-text);text-decoration:underline;display:inline-block;padding:14px 4px;margin:-14px -4px}
.consent a:focus-visible,.consent__btn:focus-visible{outline:2px solid var(--s-accent);outline-offset:2px}
.consent__btns{display:flex;flex:none;gap:4px}
.consent__btn{min-height:44px;min-width:44px;padding:0 8px;background:none;border:0;font:inherit;font-size:14px;font-weight:600;color:var(--s-text-2);cursor:pointer}
.consent__btn--yes{color:var(--s-accent)}
`;
